<a
  href="#"
  [ngbPopover]="uploadFileInstructions"
  autoClose="outside"
  container="body"
  #fetchPopover="ngbPopover"
  >Looking to upload a transaction file?</a
>

<ng-template #uploadFileInstructions>
  <div>
    <p>
      To upload a transaction file or create transactions that were received
      from an external party, please use the Clearwater Excel Cost Data tool.
      This tool will create External transactions instead of unlinked CW
      transactions. It is best practice to create an external record of the data
      that we received, for audit purposes and clarity.
    </p>

    <p>
      This tool is compatible with excel templates used for the Perseus Bulk
      panels. In the general options section, select Transactions.
    </p>

    <p>
      For help getting access to and using the Cost Data add-in, see the
      <a
        href="https://cwan.atlassian.net/wiki/spaces/PD/pages/127176999/Excel+Add-Ins+Installation+Guide"
        target="_blank"
        >installation guide</a
      >
      and
      <a
        href="https://cwan.atlassian.net/wiki/spaces/PD/pages/127173975/Cost+Data+Tool+-+SOP"
        target="_blank"
        >instructions</a
      >.
    </p>
  </div>
</ng-template>
